<template>
  <el-dialog
    title="选择产品"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    append-to-body
    :close-on-click-modal="false"
  >
    <!-- <div class="toolbar" style="margin-top: -20px"> -->
    <div class="top">
      <div class="left">
        <el-button
          type="primary"
          @click="onCreateItem()"
          :disabled="!productList || !productList.length"
        >
          <i class="fas fa-plus"></i> 确定
        </el-button>
      </div>
      <div class="right">
        <el-select
          v-model="former.dciProductModelName"
          clearable
          placeholder="选择产品型号"
          style="width: 250px"
          :disabled="true"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele"
            :label="ele"
            :value="ele"
          >
          </el-option> </el-select
        >&nbsp;
        <el-input
          v-model.trim="former.key"
          placeholder="请输入点位名称或MN或产品SN"
          @keydown.enter.native="onSubmitQuery"
          style="width: 220px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table
      :data="itemList"
      v-loading="loading"
      @selection-change="onSelectChanged"
      :row-key="getRowKey"
      ref="tableProduct"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column
        prop="DciProductModel.NameNumber"
        label="产品型号名称"
      ></el-table-column>
      <el-table-column prop="SN" label="产品SN"
        ><template slot-scope="scope">
          <el-tag v-if="scope.row.SN">
            {{ scope.row.SN }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.Remark">
            {{ scope.row.Remark }}
          </el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="DciStation.Name"
        label="点位名称"
      ></el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      itemList: [],
      modelList: [],
      loading: false,
      former: {
        dciProductModelName: "",
        key: "",
      },
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      productList: [],
      productUrl: "dci/product/stock-list/list?order=-sn",
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  mounted() {},
  watch: {
    "former.dciProductModelName": {
      handler() {
        this.productUrl = `dci/station?dciProductModelName=${this.former.dciProductModelName}&order=-sn`;
      },
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.productList = [];
      this.getModelList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/station", {
          params: {
            where: {
              // DciProductModelID: this.former.DciProductModelID,
              ID: this.former.ID,
            },
            key: this.former.key,
            dciProductModelName: this.former.dciProductModelName,
            heartbeat: this.former.heartbeat,
            ...this.pager,
            with: ["DciStation", "DciProductModel"],
            order: ["-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
          if (this.pager.page > response.data.last) {
            this.pager.page = response.data.last;
            this.getItemList();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/name/list").then(
        (response) => {
          this.modelList = response.data;

          if (this.item.DciProductModelName !== undefined) {
            this.former.dciProductModelName = this.item.DciProductModelName;
          }

          this.getItemList();
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.productList = [];
      this.$refs.tableProduct.clearSelection();
    },
    onCreateItem() {
      this.$emit("form:saved", this.productList);
      this.onClose();
    },
    onSelectChanged(options) {
      this.productList = options;
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-autocomplete li {
  line-height: normal;
  padding: 7px;
}
.my-autocomplete li .keypathName {
  text-overflow: ellipsis;
  overflow: hidden;
}
.my-autocomplete li .categoryName {
  font-size: 13px;
  color: #b4b4b4;
}
.my-autocomplete li .highlighted .categoryName {
  color: #ddd;
}
.hideSuggestion {
  display: none;
}

.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 10px 20px 10px 20px;
  margin: -30px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
  background-color: #f5f7fa;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>
